import { render, staticRenderFns } from "./OptIn.vue?vue&type=template&id=39f4a4b2"
import script from "./OptIn.vue?vue&type=script&lang=js"
export * from "./OptIn.vue?vue&type=script&lang=js"
import style0 from "./OptIn.vue?vue&type=style&index=0&id=39f4a4b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports